module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 12
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-cubes",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.products.syncVmp.title')) + "\n      ")])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('el-tabs', {
    attrs: {
      "value": _vm.tabIndex
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.products.formTabs.syncDetails'),
      "name": "1"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [
    [_c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('h2', {
      staticClass: "margin-b-20",
      staticStyle: {
        "color": "#5d5959"
      }
    }, [_c('b', [_vm._v("Vinmonopolet Produkt API")])]), _vm._v(" "), _c('el-button', {
      staticClass: "small margin-b-20",
      attrs: {
        "loading": _vm.syncLoading
      },
      on: {
        "click": function($event) {
          return _vm.startSync(true)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$t('button.fetchFromVmp').toUpperCase())), _c('br'), _vm._v(" "), _c('small', [(_vm.syncDate) ? _c('span', {
      staticStyle: {
        "color": "#2b4437",
        "display": "block",
        "margin-top": "4px",
        "text-weight": "bold"
      }
    }, [_vm._v("(Sist oppdatert: " + _vm._s(_vm.syncDate) + ")")]) : _vm._e()])])], 1), _vm._v(" "), (_vm.products.forUpdate.length) ? _c('h3', [_vm._v("\n              " + _vm._s(_vm.$t('static.products.syncVmp.existingProducts')) + "\n              "), _c('b', [_vm._v("(" + _vm._s(_vm.products.forUpdate.length) + ")")])]) : _vm._e(), _vm._v(" "), (_vm.products.forUpdate.length) ? _c('el-table', {
      staticStyle: {
        "width": "100%",
        "margin-bottom": "30px"
      },
      attrs: {
        "data": _vm.products.forUpdate,
        "max-height": "400"
      },
      on: {
        "selection-change": _vm.handleExistingProductsSelectionChange
      }
    }, [_c('el-table-column', {
      attrs: {
        "type": "selection"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "vmp",
        "label": _vm.$t('form.products.vmp.label'),
        "width": "100"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": _vm.$t('form.products.name.label'),
        "min-width": "180"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "vintage",
        "label": _vm.$t('form.products.vintage.label'),
        "width": "100"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "gtin",
        "label": _vm.$t('form.products.gtin.label'),
        "width": "150"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "alcoholPercentage",
        "label": _vm.$t('form.products.alcoholPercentage.label'),
        "width": "100"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "bottleVolume",
        "label": _vm.$t('form.products.bottle_volume.label'),
        "width": "120"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "ddpVmp",
        "label": _vm.$t('form.products.ddpVmp.label'),
        "width": "100"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "lastChanged",
        "label": _vm.$t('form.products.lastChanged.label'),
        "width": "150"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.products.forInsert.length) ? _c('h3', [_vm._v("\n              " + _vm._s(_vm.$t('static.products.syncVmp.newProducts')) + "\n              "), _c('b', [_vm._v("(" + _vm._s(_vm.products.forInsert.length) + ")")])]) : _vm._e(), _vm._v(" "), (_vm.products.forInsert.length) ? _c('el-table', {
      staticStyle: {
        "width": "100%",
        "margin-bottom": "30px"
      },
      attrs: {
        "data": _vm.products.forInsert,
        "max-height": "400"
      },
      on: {
        "selection-change": _vm.handleNewProductsSelectionChange
      }
    }, [_c('el-table-column', {
      attrs: {
        "type": "selection"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "vmp",
        "label": _vm.$t('form.products.vmp.label'),
        "width": "100"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": _vm.$t('form.products.name.label'),
        "min-width": "180"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "vintage",
        "label": _vm.$t('form.products.vintage.label'),
        "width": "100"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "gtin",
        "label": _vm.$t('form.products.gtin.label'),
        "width": "150"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "alcoholPercentage",
        "label": _vm.$t('form.products.alcoholPercentage.label'),
        "width": "100"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "bottleVolume",
        "label": _vm.$t('form.products.bottle_volume.label'),
        "width": "120"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "ddpVmp",
        "label": _vm.$t('form.products.ddpVmp.label'),
        "width": "100"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "lastChanged",
        "label": _vm.$t('form.products.lastChanged.label'),
        "width": "150"
      }
    })], 1) : _vm._e()], _vm._v(" "), _c('div', {
      staticClass: "flex",
      staticStyle: {
        "justify-content": "center"
      }
    }, [(_vm.products.forUpdate.length || _vm.products.forInsert.length) ? _c('el-button', {
      staticClass: "small margin-b-20",
      attrs: {
        "loading": _vm.syncLoading,
        "disabled": !(_vm.newProductsSelection.length || _vm.existingProductsSelection.length)
      },
      on: {
        "click": _vm.processSync
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$t('button.confirmSync').toUpperCase()))]) : _vm._e()], 1)
  ], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0188e127","hasScoped":false}!./src/app/pages/withNavigation/products/syncVmp/syncVmp.html
// module id = 2891
// module chunks = 1